import { ComponentType } from 'react';
import classNames from 'classnames';

import SlickSlider from '@ui/SlickSlider';
import { SliderArrowProps, SliderArrow } from '@ui/SliderArrow';
import { ProductDetailsSafePaymentBanner } from '@components/ProductDetailsSafePaymentBanner';
import { ProductDetailsSmartBanner } from '@components/ProductDetailsSmartBanner';

import s from './ProductDetailsFeatureBanner.sss';

export enum FeatureBannerType {
  Smart = 'smart',
  SafePayment = 'safePayment',
}

export interface FeatureBanner {
  type: FeatureBannerType,
  data?: object,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ArrowLeft: React.FC<SliderArrowProps> = ({ className, ...props }) => (
  <SliderArrow {...props} direction="left" />
);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ArrowRight: React.FC<SliderArrowProps> = ({ className, ...props }) => (
  <SliderArrow {...props} />
);

const FEATURE_BANNERS: Record<FeatureBannerType, ComponentType> = {
  [FeatureBannerType.Smart]: ProductDetailsSmartBanner,
  [FeatureBannerType.SafePayment]: ProductDetailsSafePaymentBanner,
};

interface Props {
  className?: string,
  banners: FeatureBanner[],
}

export const ProductDetailsFeatureBanner: React.FC<Props> = ({
  className,
  banners,
}) => (
  <SlickSlider
    className={classNames(s.list, className)}
    speed={400}
    prevArrow={<ArrowLeft />}
    nextArrow={<ArrowRight />}
    slidesToShow={2.2}
    centerMode={false}
    infinite={false}
    swipeToSlide={true}
    waitForAnimate={false}
    responsive={[
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: banners.length === 1 ? 1 : 1.2,
        },
      },
    ]}
  >
    {banners.map((banner) => {
      const BannerComponent = FEATURE_BANNERS[banner.type];

      return (
        <div
          key={banner.type}
          className={s.item}
        >
          {'data' in banner ? (
            <BannerComponent {...banner.data} />
          ) : (
            <BannerComponent />
          )}
        </div>
      );
    })}
  </SlickSlider>
);
